module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('employee', {
    attrs: {
      "name": "Karsten Bil Pedersen",
      "position": "Vognmand"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Marianne Fly Pedersen",
      "position": "Kontor"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Birger D. Petersen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Brian W. Weber",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Karsten L. Pedersen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Lasse Z. Bil Pedersen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Daniel S. Nielsen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Thomas Laursen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Kenneth Larsen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Uffe S. Kajhøj",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Jack Sørensen",
      "position": "Chauffør"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Frits Einspor",
      "position": "Chauffør (afløser)"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Hans Gert Clausen",
      "position": "Chauffør (afløser)"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Lars Ole Jakobsen",
      "position": "Chauffør (afløser)"
    }
  }), _vm._v(" "), _c('employee', {
    attrs: {
      "name": "Jan Hansen",
      "position": "Chauffør (afløser)"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Kontakt os\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n                    Kontaktoplysninger\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, [_c('div', {
    staticStyle: {
      "border-radius": "4px",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9166.779387510944!2d10.245455193387553!3d54.94337173829329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b2d645cbd445dd%3A0xec8e91e72899cf26!2zUC4gUGVkZXJzZW4gJiBTw7huIEFwUywgU8O4Ynkgw4ZSw5g!5e0!3m2!1sda!2sdk!4v1533388978450",
      "width": "600",
      "height": "450",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-12"
  }, [_c('b', [_vm._v("P. Pedersen & Søn")]), _vm._v(" "), _c('br'), _vm._v("\n                            CVR: 60098018\n                            "), _c('br'), _vm._v("\n                            494100 Vejgodstransport\n                            "), _c('br'), _vm._v("\n                            P-nummer: 1002107587\n                            "), _c('br'), _vm._v("\n                            Nørrebro 23\n                            "), _c('br'), _vm._v("\n                            5985 Søby Ærø\n                            "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-6 col-sm-12"
  }, [_c('b', [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v("  Telefon")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#8b0000",
      "font-weight": "bold",
      "text-decoration": "underline",
      "font-size": "24px"
    },
    attrs: {
      "href": "tel:+4540436078"
    }
  }, [_vm._v("\n                                40 43 60 78\n                            ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "fas fa-envelope"
  }), _vm._v("  E-mail")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#8b0000",
      "font-weight": "bold",
      "text-decoration": "underline",
      "font-size": "24px"
    },
    attrs: {
      "href": "mailto:karsten@p-pedersen.dk"
    }
  }, [_vm._v("\n                                karsten@p-pedersen.dk\n                            ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9daa725e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/contact.vue
// module id = 274
// module chunks = 1